<div class="flex flex-col w-full h-full min-h-[320px]">
  <!-- Cabeçalho com título e botão de alternância -->
  <div class="flex justify-between items-center mb-4 flex-shrink-0">
    <h3 class="text-lg font-semibold text-center">{{ title }}</h3>
    <button 
      (click)="toggleChartType()"
      class="flex items-center gap-2 px-3 py-1.5 text-xs font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors duration-200">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path *ngIf="chartType === 'bar'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
        <path *ngIf="chartType === 'line'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
              d="M7 12l3-3 3 3 4-4"></path>
      </svg>
      {{ chartType === 'bar' ? 'Linha' : 'Barras' }}
    </button>
  </div>
  
  <!-- Container do gráfico -->
  <div class="flex-1 flex flex-col relative pt-8 min-h-[260px]">
    <!-- Desktop: Layout fixo -->
    <div class="hidden lg:flex lg:flex-col relative w-full h-full" style="min-height: 260px;">
      <!-- Grid de fundo -->
      <div class="absolute inset-0 w-full h-full flex flex-col justify-between pt-8 pb-12">
        <ng-container *ngFor="let value of gridValues; let i = index">
          <div class="relative">
            <div class="h-px w-full bg-gray-300"></div>
            <span class="absolute left-0 top-0 transform -translate-y-1/2 text-xs text-gray-600">{{ formatGridValue(value) }}</span>
          </div>
        </ng-container>
      </div>
      
      <!-- Gráfico de Barras Desktop -->
      <div *ngIf="chartType === 'bar'" class="flex-1 flex items-end justify-around px-4 pb-6 pt-8" style="min-height: 200px;">
        <ng-container *ngFor="let item of data; let i = index">
          <div class="flex flex-col items-center justify-end relative flex-1 max-w-[60px]" style="height: 100%;">
            <!-- Estrela para o mês com maior faturamento -->
            <div *ngIf="isMaxValueMonth(i)" class="text-yellow-500 absolute -top-12 left-1/2 -translate-x-1/2 z-20 text-lg">
              ⭐
            </div>
            
            <!-- Valor acima da barra -->
            <div class="text-xs font-bold absolute -top-6 left-1/2 -translate-x-1/2 z-10 text-gray-700 whitespace-nowrap">
              {{ formatValue(item.value) }}
            </div>
            
            <!-- Barra -->
            <div class="w-full flex justify-center mb-2 relative" style="height: calc(100% - 24px);">
              <div 
                class="w-8 rounded-t-md transition-all duration-500 ease-in-out absolute bottom-0 shadow-lg" 
                [ngClass]="getColorClass(0)"
                [ngStyle]="{ 'height': getBarHeight(item.value) }"
              ></div>
            </div>
            
            <!-- Label do mês -->
            <div class="text-xs text-center w-full text-gray-600 mt-1 leading-tight">
              {{ formatMonth(item.month) }}
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Gráfico de Linha Desktop -->
      <div *ngIf="chartType === 'line'" class="flex-1 relative" style="min-height: 200px;">
        <!-- Container SVG para a linha -->
        <svg class="absolute inset-0 w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
          <!-- Área sob a linha (gradiente) -->
          <defs>
            <linearGradient id="lineGradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" [attr.stop-color]="getHexColor(0)" stop-opacity="0.3"/>
              <stop offset="100%" [attr.stop-color]="getHexColor(0)" stop-opacity="0.1"/>
            </linearGradient>
          </defs>
          
          <!-- Área preenchida -->
          <path 
            [attr.d]="getLinePath() + ' L 100 100 L 0 100 Z'"
            fill="url(#lineGradient)"
            class="transition-all duration-500 ease-in-out"
          ></path>
          
          <!-- Linha principal -->
          <path 
            [attr.d]="getLinePath()"
            fill="none"
            [attr.stroke]="getHexColor(0)"
            stroke-width="0.5"
            class="transition-all duration-500 ease-in-out"
          ></path>
        </svg>
        
        <!-- Pontos da linha -->
        <div class="absolute inset-0">
          <ng-container *ngFor="let point of getLinePoints(); let i = index">
            <!-- Estrela para o mês com maior faturamento -->
            <div *ngIf="isMaxValueMonth(i)" 
                 class="absolute text-yellow-500 text-lg transform -translate-x-1/2 -translate-y-full z-30"
                 [style.left.%]="point.x"
                 [style.top.%]="point.y">
              ⭐
            </div>
            
            <div 
              class="absolute w-2 h-2 rounded-full border-2 border-white shadow-lg transition-all duration-500 ease-in-out transform -translate-x-1/2 -translate-y-1/2 hover:scale-150 cursor-pointer"
              [ngClass]="getColorClass(0)"
              [style.left.%]="point.x"
              [style.top.%]="point.y"
              [title]="formatMonth(point.month) + ': ' + formatValue(point.value)"
            ></div>
          </ng-container>
        </div>
        
        <!-- Labels dos meses (parte inferior) -->
        <div class="absolute bottom-0 left-0 right-0 flex justify-between px-4 pb-2">
          <ng-container *ngFor="let item of data; let i = index">
            <div class="text-xs text-center text-gray-600 leading-tight">
              {{ formatMonth(item.month) }}
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Mobile/Tablet: Layout com scroll horizontal -->
    <div class="lg:hidden relative w-full h-full">
      <!-- Indicador de scroll -->
      <div class="absolute top-0 right-0 bg-gray-100 text-gray-500 text-xs px-2 py-1 rounded-bl-md scroll-indicator z-20">
        ← Role para ver mais →
      </div>
      
      <!-- Grid de fundo fixo (valores na vertical) -->
      <div class="absolute inset-0 w-full h-full flex flex-col justify-between pt-8 pb-12 pointer-events-none z-10">
        <ng-container *ngFor="let value of gridValues; let i = index">
          <div class="relative">
            <div class="h-px w-full bg-gray-300"></div>
            <span class="absolute left-0 top-0 transform -translate-y-1/2 text-xs text-gray-600 bg-white pr-2 pointer-events-none">{{ formatGridValue(value) }}</span>
          </div>
        </ng-container>
      </div>
      
  <!-- Container com scroll horizontal -->
  <div class="overflow-x-auto overflow-y-visible h-full relative z-5">
  <div class="relative min-w-[800px] h-full pt-12">
          
          <!-- Gráfico de Barras Mobile -->
          <div *ngIf="chartType === 'bar'" class="flex-1 flex items-end justify-around h-full px-4">
            <ng-container *ngFor="let item of data; let i = index">
              <div class="flex flex-col items-center justify-end h-full relative w-16">
                <!-- Estrela para o mês com maior faturamento -->
                <div *ngIf="isMaxValueMonth(i)" class="text-yellow-500 absolute -top-12 left-1/2 -translate-x-1/2 z-20 text-lg">
                  ⭐
                </div>
                
                <!-- Valor acima da barra -->
                <div class="text-xs font-bold absolute -top-6 left-1/2 -translate-x-1/2 z-10 text-gray-700 whitespace-nowrap">
                  {{ formatValue(item.value) }}
                </div>
                
                <!-- Barra -->
                <div class="w-full flex justify-center mb-2 h-full relative">
                  <div 
                    class="w-10 rounded-t-md transition-all duration-500 ease-in-out absolute bottom-0 shadow-lg" 
                    [ngClass]="getColorClass(0)"
                    [ngStyle]="{ 'height': getBarHeight(item.value) }"
                  ></div>
                </div>
                
                <!-- Label do mês -->
                <div class="text-xs text-center w-full text-gray-600 mt-1 leading-tight">
                  {{ formatMonth(item.month) }}
                </div>
              </div>
            </ng-container>
          </div>

          <!-- Gráfico de Linha Mobile -->
          <div *ngIf="chartType === 'line'" class="flex-1 relative h-full">
            <!-- Container SVG para a linha -->
            <svg class="absolute inset-0 w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
              <!-- Área sob a linha (gradiente) -->
              <defs>
                <linearGradient id="lineGradientMobile" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" [attr.stop-color]="getHexColor(0)" stop-opacity="0.3"/>
                  <stop offset="100%" [attr.stop-color]="getHexColor(0)" stop-opacity="0.1"/>
                </linearGradient>
              </defs>
              
              <!-- Área preenchida -->
              <path 
                [attr.d]="getLinePath() + ' L 100 100 L 0 100 Z'"
                fill="url(#lineGradientMobile)"
                class="transition-all duration-500 ease-in-out"
              ></path>
              
              <!-- Linha principal -->
              <path 
                [attr.d]="getLinePath()"
                fill="none"
                [attr.stroke]="getHexColor(0)"
                stroke-width="0.8"
                class="transition-all duration-500 ease-in-out"
              ></path>
            </svg>
            
            <!-- Pontos da linha -->
            <div class="absolute inset-0">
              <ng-container *ngFor="let point of getLinePoints(); let i = index">
                <!-- Estrela para o mês com maior faturamento -->
                <div *ngIf="isMaxValueMonth(i)" 
                     class="absolute text-yellow-500 text-lg transform -translate-x-1/2 -translate-y-full z-30"
                     [style.left.%]="point.x"
                     [style.top.%]="point.y">
                  ⭐
                </div>
                
                <div 
                  class="absolute w-3 h-3 rounded-full border-2 border-white shadow-lg transition-all duration-500 ease-in-out transform -translate-x-1/2 -translate-y-1/2 hover:scale-125 cursor-pointer"
                  [ngClass]="getColorClass(0)"
                  [style.left.%]="point.x"
                  [style.top.%]="point.y"
                  [title]="formatMonth(point.month) + ': ' + formatValue(point.value)"
                ></div>
              </ng-container>
            </div>
            
            <!-- Labels dos meses (parte inferior) -->
            <div class="absolute bottom-0 left-0 right-0 flex justify-between px-4 pb-2">
              <ng-container *ngFor="let item of data; let i = index">
                <div class="text-xs text-center text-gray-600 leading-tight">
                  {{ formatMonth(item.month) }}
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
